import {
    getData,
    postData,
    patchData,
    deleteData,
    getDataPublic
} from './Services'

export const getEmpresas = async () => {
    const res = await getData(`/empresas`);
    return res
}

export const getEmpresasById = async (id) => {
    const res = await getData(`/empresas/${id}`)
    return res
}

export const postEmpresas = async (body) => {
    const res = await postData('/empresas', body)
    return res
}

export const patchEmpresas = async (id, body) => {
    const res = await patchData(`/empresas/${id}`, body)
    return res
}

export const deleteEmpresas = async (id) => {
    const res = await deleteData(`/empresas/${id}`)
    return res
}

export const getLoginEmpresasById = async (id) => {
    const endpoint = `/empresas/1`;
        const res = await getDataPublic(endpoint,false);
        return res;
};
